import {InstallationListController} from './installation-list.controller';
import {ActivationHelpController} from './activation-help.controller';
import {ActivationCompleteController} from './activation-complete.controller';
import {LoginFormController} from './login-form.controller';
import {ResetPasswordController} from './reset-password.controller';
import {InformationController} from './information.controller';
import {VerifyCodeController} from './verify-code.controller';
import {SetPhoneController} from './set-phone.controller';
import {RedirectToDestinationController} from './RedirectToDestinationController';
import {ReasonController} from './ReasonController';
import {LoggedOutController} from './LoggedOutController';
import {NoInstallationUserController} from "./NoInstallationUserController";
import * as sharedResolves from '../shared/shared.resolves';
import * as resolves from './login.resolves';

/* @ngInject */
export function loginRoutes($stateProvider) {
    $stateProvider
        .state('workerNameRequired', {
            url: '/workerNameRequired',
            templateUrl: 'app/login/workerNameRequired.html'
        })
        .state('ipBlocked', {
            url: '/ipBlocked',
            templateUrl: 'app/login/ipBlocked.html'
        })
        .state('NoInstallationUser', {
            url: '/NoInstallationUser',
            templateUrl: 'app/login/NoInstallationUser.html',
            controller: NoInstallationUserController,
            controllerAs: 'vm'
        })
        .state('loggedOut', {
            url: '/loggedOut?url&workerName',
            templateUrl: 'app/login/loggedOut.html',
            controller: LoggedOutController,
            controllerAs: 'vm'
        })
        .state('login', {
            url: '/login',
            templateUrl: 'app/login/login-form.html',
            controller: LoginFormController,
            controllerAs: 'vm',
            resolve: LoginResolve
        })
        .state('login.username', {
            url: '/username?username',
            template: '<div ui-view=""></div>',
            controller: LoginFormController,
            controllerAs: 'vm'
        })
        .state('login.account', {
            url:'/account?authenticationRequired',
            template: '<div ui-view=""></div>',
            controller: LoginFormController,
            controllerAs: 'vm'
        })
        .state('setpassword', {
            url: '/setpassword?id&username',
            templateUrl: 'app/login/reset-password.html',
            controller: ResetPasswordController,
            controllerAs: 'vm',
            params: {
                id: null,
                username: null,
                email: null
            },
            resolve: activateResolve
        })
        .state('verifycode', {
            url: '/verify?type',
            templateUrl: 'app/login/verify-code.html',
            controller: VerifyCodeController,
            controllerAs: 'vm',
            resolve: {
                userSession: sharedResolves.userSessions,
                uuid: resolves.getUuid,
                email: resolves.getEmail
            }
        })
        .state('activate', {
            abstract: true,
            template: '<div ui-view=""></div>',
            url: '/activate'
        })
        .state('activate.help', {
            url: '/help?state&popup',
            templateUrl: 'app/login/activation-help.html',
            controller: ActivationHelpController,
            controllerAs: 'vm'
        })
        .state('activate.complete', {
            url: '/complete?id',
            templateUrl: 'app/login/activation-complete.html',
            controller: ActivationCompleteController,
            controllerAs: 'vm',
            resolve: {
                authenticatedUser: resolves.authenticatedUser,
                installations: resolves.installationsForAuthenticatedUser,
            }
        })
        .state('activate.email', {
            url: '/account/email',
            params: {
                state: null,
                popup: null,
                username: null,
            },
            template: `<email-container-component destination-organization="$resolve.destinationOrganization" 
                                                  user-sessions="$resolve.userSessions">
                       </email-container-component>`,
            resolve: {
                destinationOrganization: (destinationService) => destinationService.getDestinationOrganization(),
                userSessions: (userSessionService) => userSessionService.getUserSessions()
            }
        })
        .state('activate.username', {
            url: '/account/username',
            params: {
                state: null,
                popup: null
            },
            template: `<username-container-component></username-container-component>`,
        })
        .state('activate.verify', {
            url: '/account/verify',
            params: {
                state: null,
                email: null,
                username: null,
                popup: null
            },
            template: `<verification-container-component destination-organization="$resolve.destinationOrganization"
                                                         user-sessions="$resolve.userSessions">
                       </verification-container-component>`,
            resolve: {
                destinationOrganization: (destinationService) => destinationService.getDestinationOrganization(),
                userSessions: (userSessionService) => userSessionService.getUserSessions()
            }
        })
        .state('activate.phone', {
            url: '/account/phone?state&popup',
            templateUrl: 'app/login/set-phone.html',
            controller: SetPhoneController,
            controllerAs: 'vm',
            params: {
                state: null,
                username: null,
                email: null
            },
            resolve: activateAccountResolve
        })
        .state('deviceTokenInfo', {
            url: '/loginInformation',
            templateUrl: 'app/login/device-token-information.html',
            controller: InformationController,
            controllerAs: 'vm'
        })
        .state('installationlist', {
            url: '/installationList',
            templateUrl: 'app/login/installation-list.html',
            controller: InstallationListController,
            controllerAs: 'vm',
            resolve: InstallationsResolve
        })
        .state('loginReason', {
            url: '/loginReason?installationUserId&workerName',
            templateUrl: 'app/login/Reason.html',
            controller: ReasonController,
            controllerAs: 'vm',
        })
        .state('redirectToDestination', {
            url: '/redirectToDestination?installationUserId&loginReason',
            templateUrl: 'app/login/RedirectToDestinationController.html',
            controller: RedirectToDestinationController,
            controllerAs: 'vm',
            resolve: DestinationRedirectResolve
        });
}


let activateResolve = {
    authenticatedUser: resolves.authenticatedUser,
    userSession: sharedResolves.userSessions,
    uuid: resolves.getUuid
};

let activateAccountResolve = {
    account: function() {
        return null;
    },
    userSecurityContext: resolves.getSecurityContext,
    usernameApproved: resolves.getApprovalForUsername,
    userSession: sharedResolves.userSessions,
    destinationOrganization: sharedResolves.destinationOrganization
};

let InstallationsResolve = {
    installationUsers: resolves.installationUsers,
};

let DestinationRedirectResolve = {
    destinationRedirectData: resolves.destinationRedirectData
};

let LoginResolve = {
    destinationInstallation: sharedResolves.destinationInstallation,
    destinationOrganization: sharedResolves.destinationOrganization
};
